import {
  Car, Award, Users, Calendar, Star, BookOpen, Clock, FileText,
  GraduationCap, CheckCircle, Shield, Heart, Phone, MapPin, Zap,
  Trophy, Target, ThumbsUp, MessageCircle, CreditCard, Smile,
  Navigation, Truck, Key, Flag, Clipboard, BarChart, Headphones,
  Gift, Percent, AlertCircle, Info, Home, Globe, Camera,
} from 'lucide-react';

export const ICON_MAP = {
  Car, Award, Users, Calendar, Star, BookOpen, Clock, FileText,
  GraduationCap, CheckCircle, Shield, Heart, Phone, MapPin, Zap,
  Trophy, Target, ThumbsUp, MessageCircle, CreditCard, Smile,
  Navigation, Truck, Key, Flag, Clipboard, BarChart, Headphones,
  Gift, Percent, AlertCircle, Info, Home, Globe, Camera,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const DynamicIcon = ({ name, className }) => {
  const Icon = ICON_MAP[name] || Star;
  return <Icon className={className} />;
};
